<div class="row">
    <div class="text-center text-danger" *ngIf="!title"> Error Please try again later </div>
    <div class="text-center text-danger" *ngIf="title"> {{title}} </div>
</div>

